import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
// import { makeStyles } from "@mui/styles"
// import { RoomStyle } from "./RoomStyle";
import AudioSettings from "./AudioSettings";
import VideoSettings from "./VideoSettings";

// const useStyles = makeStyles((theme) => RoomStyle(theme));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserWebcamSettings({
  userWebcamSettingsOpen,
  setUserWebcamSettingsOpen,
  selectedAudioInputDevice,
  setSelectedAudioInputDevice,
  selectedAudioOutputDevice,
  setSelectedAudioOutputDevice,
  selectedVideoDevice,
  setSelectedVideoDevice,
  myVideoSettingsRef
}) {
  const [tabValue, setTabValue] = useState("1");
  // const classes = useStyles();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Dialog
        open={userWebcamSettingsOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setUserWebcamSettingsOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent sx={{ maxWidth: "500px", minWidth: "500px" }}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleTabChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Audio Settings" value="1" />
                <Tab label="Video Settings" value="2" />
              </TabList>
            </Box>

            <TabPanel value="1">
              <div>
                {selectedAudioInputDevice ?
                  <AudioSettings
                    selectedAudioTypeDevice={selectedAudioInputDevice}
                    setSelectedAudioTypeDevice={setSelectedAudioInputDevice}
                    otherAudioTypeDevice={selectedAudioOutputDevice}
                    selectedVideoDevice={selectedVideoDevice}
                    audioType="audioinput"
                  /> : <div>No audio available</div>
                }
              </div>

              <div style={{ marginTop: '30px' }}>
                {selectedAudioOutputDevice ?
                  <AudioSettings
                    selectedAudioTypeDevice={selectedAudioOutputDevice}
                    setSelectedAudioTypeDevice={setSelectedAudioOutputDevice}
                    audioType="audiooutput"
                  /> : <div>No audio available</div>
                }
              </div>
            </TabPanel>

            <TabPanel value="2">
              {selectedVideoDevice ?
                <VideoSettings
                  selectedVideoDevice={selectedVideoDevice}
                  setSelectedVideoDevice={setSelectedVideoDevice}
                  selectedAudioInputDevice={selectedAudioInputDevice}
                  selectedAudioOutputDevice={selectedAudioOutputDevice}
                  myVideoSettingsRef={myVideoSettingsRef}
                /> : <div>No video available</div>
              }
            </TabPanel>
          </TabContext>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUserWebcamSettingsOpen(false)}>
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
